var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "basket-preview-wrapper h-100",
      class: {
        empty: !_vm.basketItems.length,
        "open-hover": _vm.hover,
        "open-right": !_vm.hover,
      },
    },
    [
      _c("div", { staticClass: "position-relative h-100" }, [
        _c(
          "div",
          {
            staticClass:
              "basket-preview d-flex flex-column flex-nowrap bg-white shadow w-100",
          },
          [
            _c(
              "header",
              {
                staticClass:
                  "basket-preview-header border-bottom px-3 py-2 d-flex align-items-center justify-content-between",
              },
              [
                _c("span", { staticClass: "h3 mb-0" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$translate("Ceres::Template.basketPreview")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "toggle-basket-preview",
                        rawName: "v-toggle-basket-preview",
                      },
                    ],
                    staticClass: "close p-0 m-0",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "40",
                          height: "40",
                          viewBox: "0 0 40 40",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("rect", {
                          attrs: {
                            width: "40",
                            height: "40",
                            rx: "20",
                            fill: "white",
                            "fill-opacity": "0.68",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M28.3332 11.667L11.6665 28.3337M11.6665 11.667L28.3332 28.3337",
                            stroke: "#090909",
                            "stroke-width": "1.66667",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.basketNotifications.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.basketNotifications, function (notification) {
                    return _c(
                      "div",
                      {
                        key: notification.id,
                        staticClass: "w-100 alert alert-danger",
                      },
                      [_c("div", [_vm._v(_vm._s(notification.message))])]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "basket-preview-content d-flex flex-fill" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "item-list d-flex flex-fill flex-nowrap flex-column overflow-auto px-3",
                  },
                  [
                    _c("basket-list", {
                      attrs: {
                        "is-preview": true,
                        "multi-language": {
                          RemoveItem: _vm.multiLanguage.RemoveItem,
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "before-basket-item",
                            fn: function () {
                              return [_vm._t("before-basket-item")]
                            },
                            proxy: true,
                          },
                          {
                            key: "after-basket-item",
                            fn: function () {
                              return [_vm._t("after-basket-item")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _vm.basketItems.length > 0
                      ? [
                          _c("hr"),
                          _vm._v(" "),
                          _c("div", { staticClass: "basket-footer" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "net-total d-flex justify-content-between my-1",
                              },
                              [
                                _c("p", { staticClass: "small" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.basketValue"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.showNetPrices
                                            ? _vm.basket.itemSumNet
                                            : _vm.basket.itemSum
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "shipping-net-total d-flex justify-content-between my-1",
                              },
                              [
                                _c("p", { staticClass: "small" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.basketShippingCosts"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.showNetPrices
                                            ? _vm.basket.shippingAmountNet
                                            : _vm.basket.shippingAmount
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.basket.couponCode && _vm.basket.couponDiscount
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "shipping-coupon-discount d-flex justify-content-between my-1",
                                  },
                                  [
                                    _c("p", { staticClass: "small" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.basketCoupon"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.basket.couponDiscount
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "final-net-total d-flex align-items-center justify-content-between my-1",
                              },
                              [
                                _c("p", { staticClass: "h5" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.basketTotalSum"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "small text-muted mr-2" },
                                    [
                                      _vm._v(
                                        "\n                    (" +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.basketVAT"
                                            )
                                          ) +
                                          ")\n                  "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.showNetPrices
                                            ? _vm.basket.basketAmountNet
                                            : _vm.basket.basketAmount
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", { staticClass: "basket-cross-products" }, [
                      _c("p", { staticClass: "h5 font-weight-medium" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.multiLanguage.BasketCrossSellingTitle) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cross-products mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "cross-product d-flex my-3" },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.multiLanguage.ProductLink1,
                                  "aria-label": _vm.multiLanguage.ProductTitle1,
                                },
                              },
                              [
                                _c("lazy-img", {
                                  ref: "itemLazyImage",
                                  attrs: {
                                    "image-url":
                                      "https://cdn02.plentymarkets.com/6wg68w8zahno/item/images/12406442/preview/TPU-130x60---1.jpg",
                                    alt: _vm.multiLanguage.ProductTitle1,
                                    title: _vm.multiLanguage.ProductTitle1,
                                    "picture-class": "img-fluid",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-3 cross-product-info" },
                              [
                                _c(
                                  "p",
                                  { staticClass: "title font-weight-medium" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.multiLanguage.ProductTitle1
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    staticClass: "size text-muted",
                                    on: {
                                      change: function ($event) {
                                        _vm.selectedCrossProduct[1] =
                                          $event.target.value
                                      },
                                    },
                                  },
                                  _vm._l(_vm.crossProducts[1], function (item) {
                                    return _c(
                                      "option",
                                      {
                                        key: item.id,
                                        domProps: {
                                          value: item.id,
                                          selected:
                                            parseInt(
                                              _vm.selectedCrossProduct[1]
                                            ) === item.id,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(item.size) +
                                            "\n                    "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "price font-weight-bold" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.selectedProductPrice1
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    ref: "button1",
                                    staticClass:
                                      "mt-2 add-to-basket d-flex align-items-center",
                                    attrs: {
                                      "aria-label": _vm.multiLanguage.BasketAdd,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addToCart(1)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "mr-1" }, [
                                      _vm._v(
                                        _vm._s(_vm.multiLanguage.BasketAdd)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M5.00014 14H18.1359C19.1487 14 19.6551 14 20.0582 13.8112C20.4134 13.6448 20.7118 13.3777 20.9163 13.0432C21.1485 12.6633 21.2044 12.16 21.3163 11.1534L21.9013 5.88835C21.9355 5.58088 21.9525 5.42715 21.9031 5.30816C21.8597 5.20366 21.7821 5.11697 21.683 5.06228C21.5702 5 21.4155 5 21.1062 5H4.50014M2 2H3.24844C3.51306 2 3.64537 2 3.74889 2.05032C3.84002 2.09463 3.91554 2.16557 3.96544 2.25376C4.02212 2.35394 4.03037 2.48599 4.04688 2.7501L4.95312 17.2499C4.96963 17.514 4.97788 17.6461 5.03456 17.7462C5.08446 17.8344 5.15998 17.9054 5.25111 17.9497C5.35463 18 5.48694 18 5.75156 18H19M7.5 21.5H7.51M16.5 21.5H16.51M8 21.5C8 21.7761 7.77614 22 7.5 22C7.22386 22 7 21.7761 7 21.5C7 21.2239 7.22386 21 7.5 21C7.77614 21 8 21.2239 8 21.5ZM17 21.5C17 21.7761 16.7761 22 16.5 22C16.2239 22 16 21.7761 16 21.5C16 21.2239 16.2239 21 16.5 21C16.7761 21 17 21.2239 17 21.5Z",
                                            stroke: "#121926",
                                            "stroke-width": "1.5",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "cross-product d-flex my-3" },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.multiLanguage.ProductLink2,
                                  "aria-label": _vm.multiLanguage.ProductTitle2,
                                },
                              },
                              [
                                _c("lazy-img", {
                                  ref: "itemLazyImage",
                                  attrs: {
                                    "image-url":
                                      "https://cdn02.plentymarkets.com/6wg68w8zahno/item/images/12421780/preview/Cleanilo-Reinigungsspray-Frontansicht.png",
                                    alt: _vm.multiLanguage.ProductTitle2,
                                    title: _vm.multiLanguage.ProductTitle2,
                                    "picture-class": "img-fluid",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-3 cross-product-info" },
                              [
                                _c(
                                  "p",
                                  { staticClass: "title font-weight-medium" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.multiLanguage.ProductTitle2
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "size text-muted" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.crossProducts[2][0].size) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "price font-weight-bold" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.selectedProductPrice2
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    ref: "button2",
                                    staticClass:
                                      "mt-2 add-to-basket d-flex align-items-center",
                                    attrs: {
                                      "aria-label": _vm.multiLanguage.BasketAdd,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addToCart(2)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "mr-1" }, [
                                      _vm._v(
                                        _vm._s(_vm.multiLanguage.BasketAdd)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M5.00014 14H18.1359C19.1487 14 19.6551 14 20.0582 13.8112C20.4134 13.6448 20.7118 13.3777 20.9163 13.0432C21.1485 12.6633 21.2044 12.16 21.3163 11.1534L21.9013 5.88835C21.9355 5.58088 21.9525 5.42715 21.9031 5.30816C21.8597 5.20366 21.7821 5.11697 21.683 5.06228C21.5702 5 21.4155 5 21.1062 5H4.50014M2 2H3.24844C3.51306 2 3.64537 2 3.74889 2.05032C3.84002 2.09463 3.91554 2.16557 3.96544 2.25376C4.02212 2.35394 4.03037 2.48599 4.04688 2.7501L4.95312 17.2499C4.96963 17.514 4.97788 17.6461 5.03456 17.7462C5.08446 17.8344 5.15998 17.9054 5.25111 17.9497C5.35463 18 5.48694 18 5.75156 18H19M7.5 21.5H7.51M16.5 21.5H16.51M8 21.5C8 21.7761 7.77614 22 7.5 22C7.22386 22 7 21.7761 7 21.5C7 21.2239 7.22386 21 7.5 21C7.77614 21 8 21.2239 8 21.5ZM17 21.5C17 21.7761 16.7761 22 16.5 22C16.2239 22 16 21.7761 16 21.5C16 21.2239 16.2239 21 16.5 21C16.7761 21 17 21.2239 17 21.5Z",
                                            stroke: "#121926",
                                            "stroke-width": "1.5",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.basketItems.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "basket-totals bg-white d-flex flex-nowrap flex-column",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "basket-buttons d-flex px-3 py-3" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-block btn-basket font-weight-medium d-flex align-items-center justify-content-center m-0",
                                attrs: {
                                  href: _vm.$ceres.urls.basket,
                                  rel: "nofollow",
                                  title: _vm.$translate(
                                    "Ceres::Template.basket"
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate("Ceres::Template.basket")
                                    ) +
                                    "\n              "
                                ),
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "24",
                                      height: "24",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M5.00014 14H18.1359C19.1487 14 19.6551 14 20.0582 13.8112C20.4134 13.6448 20.7118 13.3777 20.9163 13.0432C21.1485 12.6633 21.2044 12.16 21.3163 11.1534L21.9013 5.88835C21.9355 5.58088 21.9525 5.42715 21.9031 5.30816C21.8597 5.20366 21.7821 5.11697 21.683 5.06228C21.5702 5 21.4155 5 21.1062 5H4.50014M2 2H3.24844C3.51306 2 3.64537 2 3.74889 2.05032C3.84002 2.09463 3.91554 2.16557 3.96544 2.25376C4.02212 2.35394 4.03037 2.48599 4.04688 2.7501L4.95312 17.2499C4.96963 17.514 4.97788 17.6461 5.03456 17.7462C5.08446 17.8344 5.15998 17.9054 5.25111 17.9497C5.35463 18 5.48694 18 5.75156 18H19M7.5 21.5H7.51M16.5 21.5H16.51M8 21.5C8 21.7761 7.77614 22 7.5 22C7.22386 22 7 21.7761 7 21.5C7 21.2239 7.22386 21 7.5 21C7.77614 21 8 21.2239 8 21.5ZM17 21.5C17 21.7761 16.7761 22 16.5 22C16.2239 22 16 21.7761 16 21.5C16 21.2239 16.2239 21 16.5 21C16.7761 21 17 21.2239 17 21.5Z",
                                        stroke: "#121926",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-block btn-checkout font-weight-medium d-flex align-items-center justify-content-center m-0",
                                attrs: {
                                  href: _vm.$ceres.urls.checkout,
                                  rel: "nofollow",
                                  title: _vm.$translate(
                                    "Ceres::Template.basketCheckout"
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.basketCheckout"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        directives: [
          { name: "toggle-basket-preview", rawName: "v-toggle-basket-preview" },
        ],
        staticClass: "basket-preview-overlay",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }